export default __webpack_public_path__ + "static/media/Monica_9781408347218.02eeec99.jpg";